import { QueryEntity } from '@datorama/akita';
import { SearchTermsStore, SearchTermsState } from './search-terms.store';
import { SearchTerm, SearchType, ESearchScopes } from './search-term.model';
import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RouterQuery } from '@datorama/akita-ng-router-store';
import { getPathFromUrl } from '../../shared/utils/router';

@Injectable()
export class SearchTermsQuery extends QueryEntity<SearchTermsState, SearchTerm> {
  selectFilters$: Observable<SearchTerm[]> = this.selectAll();
  selectFilterTypes$: Observable<SearchType[]> = this.select(state => state.searchTypes).pipe(
    map(items => items.filter(item => item.type !== 'ISRC' && item.type !== 'SONG_CODE'))
  );
  selectActiveTerms$: Observable<{ clauses: any }> = this.selectAll().pipe(
    map(terms => {
      return terms
        .filter(term => term.selected && Array.isArray(term.selected) && term.selected.length)
        .reduce(
          (buffer, term) => {
            const { type, selected, contentType = 'queries' } = term;

            const nextTerm = {
              type,
              [contentType]: selected.map(value =>
                contentType === 'queries'
                  ? value
                  : {
                      type,
                      tag: value,
                    }
              ),
            };

            buffer.clauses.push(nextTerm);

            return buffer;
          },
          { clauses: [] }
        );
    })
  );

  routerIsSearchOrHome$: Observable<boolean> = this.routerQuery
    .select(state => (state.state ? state.state.url : '/'))
    .pipe(
      filter(v => Boolean(v) && typeof v === 'string'),
      map(url => getPathFromUrl(url) === '/')
    );

  selectIsActive$: Observable<boolean> = this.select(state => state.ui.searchAreaActive);

  selectSearchAreaActive$: Observable<boolean> = combineLatest([this.selectIsActive$, this.routerIsSearchOrHome$]).pipe(
    map(([searchAreaActive, routerIsSearch]) => {
      return routerIsSearch || searchAreaActive;
    })
  );
  selectOptions$: Observable<any> = this.select(state => state.options);

  selectHasActiveInputs$: Observable<boolean> = this.selectAll().pipe(map(terms => terms.length > 1));

  selectSearchScope$: Observable<ESearchScopes> = this.select(state => state.searchScope);

  areSearchPreferencesAvailable$: Observable<boolean> = this.selectSearchScope$.pipe(
    map((scope: ESearchScopes) => scope === ESearchScopes.RECORDINGS)
  );

  constructor(protected store: SearchTermsStore, protected routerQuery: RouterQuery) {
    super(store);
  }
}
